import { KitDetails } from '@components/Product/Shared/KitsTab/KitDetails';
import { styled } from '@mui/material';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { EmptyTab } from 'src/components/EmptyTab';
import PartsCatalogue from 'src/components/Product/Desktop/Panels/PartsCatalogue/PartsCatalogue';
import { useProduct } from 'src/providers/Product';

const StyledBomTabPanel = styled('div')`
  padding: 0 1em 1em;
  height: 100%;
`;

const trailingSlashRegex = /\/+$/;

export function PartsCataloguePanelDesktop() {
  const { path, url } = useRouteMatch();
  const { bom } = useProduct();
  const location = useLocation();

  return (
    <StyledBomTabPanel>
      <Switch>
        <Route path={`${path}/kit/:detailId`}>
          <KitDetails />
        </Route>
        <Route path={`${path}/:detailId`}>
          <PartsCatalogue />
        </Route>
        <Route path={path} exact>
          {bom ? (
            <Redirect
              to={{
                pathname: `${url.replace(trailingSlashRegex, '')}/${bom.id}`,
                state: location.state,
              }}
            />
          ) : (
            /* istanbul ignore next */ <EmptyTab />
          )}
        </Route>
      </Switch>
    </StyledBomTabPanel>
  );
}
